import { FC } from 'react';

import cx from 'classnames';
import { useCompleteModal } from 'modal.react.js';
import { Arrow, ToggleLayer } from 'react-laag';
import { useDispatch } from 'react-redux';

import Dropdown from 'components/shared/Dropdown';
import { deleteTripEventAction } from 'store/itinerariesItem';

import Button from '../../../../../../../../shared/Button';
import s from './index.module.css';
import { ITooltipDialogProps } from './types';

const TooltipDialog: FC<ITooltipDialogProps> = ({
  tripEventId: id,
  children,
  className,
  onSubmit,
  text = 'Are you sure you want to delete this?',
  cancelButtonText = 'No',
  confirmButtonText = 'Yes',
}) => {
  const dispatch = useDispatch();
  const { success } = useCompleteModal<false>();

  const deleteTripEventHandler = () => dispatch(deleteTripEventAction({ id }));

  return (
    <ToggleLayer
      fixed
      closeOnOutsideClick
      renderLayer={({ isOpen, close, layerProps, arrowStyle, layerSide }) =>
        isOpen && (
          <div ref={layerProps.ref} className="layer" style={{ ...layerProps.style, zIndex: 99999 }}>
            <Dropdown className={cx(s.wrapper, className, { [s['wrapper-wide']]: !id })}>
              <div className={s.body}>{text}</div>
              <div className={s.buttons}>
                <Button type="default" size="small" onClick={close} className={s.button}>
                  {cancelButtonText}
                </Button>
                <Button
                  type="default"
                  size="small"
                  onClick={() => {
                    if (id) {
                      deleteTripEventHandler();
                      success(false);
                    }
                    onSubmit();
                  }}
                  className={s.button}
                >
                  {confirmButtonText}
                </Button>
              </div>
            </Dropdown>
            <Arrow
              style={{ ...arrowStyle, zIndex: '22' }}
              layerSide={layerSide}
              borderWidth={1}
              borderColor="rgba(0, 0, 0, 0.04)"
              backgroundColor="#fff"
              angle={50}
              roundness={0.5}
              size={6}
            />
          </div>
        )
      }
      placement={{
        anchor: 'TOP_CENTER',
        autoAdjust: true,
        triggerOffset: 10,
      }}
    >
      {({ triggerRef, toggle }) => (
        <div className={s.iconWrapper} ref={triggerRef} onClick={toggle}>
          {children}
        </div>
      )}
    </ToggleLayer>
  );
};

export default TooltipDialog;
